import SimulationPage from '@/modules/quant/simulation/simulation-page';
import { requireCapability } from '@/utils/route-guards';
import { createFileRoute } from '@tanstack/react-router';

export const Route = createFileRoute(
  '/_dashboard/dashboard/quant/simulation/',
)({
  beforeLoad: () => requireCapability('quantLab'),
  component: SimulationPage,
});
